if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.readyToShipText = this.querySelector('.js-product-form-ready-to-ship-text');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonLoadingSpinner = this.querySelector('.loading__spinner');
        this.submitPriceContainer = this.querySelector('.js-product-form-submit-price-container');
        this.readyToShipText = this.querySelector('.js-product-form-ready-to-ship-text');
        this.preOrderButton = document.querySelector('.js-product-atc-pre-order');
        this.bundlePreOrderButton = document.querySelector('.js-product-bundle-pre-order-atc');
        this.preOrderButtonShipDate = this.preOrderButton?.querySelector('.js-product-atc-pre-order-ship-estimate-date') || null;
        this.ctaEl = this.submitButton.querySelector('.product-form__atc-cta-text');
        this.compareEl = this.submitButton.querySelector('.js-product-form-submit-compare-at-price');
        this.priceEl = this.submitButton.querySelector('.js-product-form-submit-price');
        this.variantIndex = new Map(
          (window.SDG?.Data?.productJson?.variants || []).map(v => [String(v.id), v])
        );
        this.cachedVariantId = null;
        this.cachedVariant = null;
        this.preOrderButtonDays = this.preOrderButton?.dataset.preorderDays || null;
        this.bundlePreOrderButtonDays = this.bundlePreOrderButton?.dataset.bundlePreorderDays || null;
        this.bundlePreOrderButtonShipDate = this.bundlePreOrderButton?.querySelector('.js-bundle-ship-estimate-date') || null;

        if (this.preOrderButton) {
          this.preOrderButton.addEventListener('click', this.preOrderClickHandler.bind(this));
        }

        // When the variant id changes, ensure our cache resets and button text refreshes.
        this.variantIdInput?.addEventListener('change', () => {
          this.cachedVariantId = null;
          // Next tick so any theme price DOM updates can land first; we also have robust fallback.
          setTimeout(() => this.refreshSubmitFromPDP(), 0);
        });

        // Catch any option change (works for single-option or multi-option products).
        this.onVariantChange = this.onVariantChange.bind(this);
        this.form.addEventListener('change', this.onVariantChange);

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Initial paint sync (covers cases where page loads with a preselected variant)
        this.refreshSubmitFromPDP();
        
        // Set Pre-Order ship date
        this.formatPreOrderShipDate(
          this.preOrderButtonDays,
          this.preOrderButton,
          this.preOrderButtonShipDate,
        );
      }

      // --- Helpers ----------------------------------------------------------------

      formatMoney(cents) {
        try {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents);
          }
        } catch (e) {}
        const n = Math.round(Number(cents)) / 100;
        return `$${n.toFixed(2)}`;
      }

      formatPreOrderShipDate(
        preOrderShippingMessage,
        preOrderButton,
        preOrderButtonShipDate,
      ) {
        if (!preOrderShippingMessage
          && !preOrderButton
          && !preOrderButtonShipDate
        ) return;

        let shippingDays = null;

        if (preOrderShippingMessage) {
          shippingDays = parseInt(preOrderShippingMessage, 10);
        }

        if (shippingDays) {
          const date = new Date();
          date.setDate(date.getDate() + shippingDays);
          preOrderButtonShipDate.innerText = date.toLocaleString('en-US',
            {
              month: 'short',
              day: 'numeric',
            },
          );
        }
      }

      onVariantChange(e) {
        // If any option or variant id changes, refresh button state/text
        if (
          e.target?.name === 'id' ||
          (typeof e.target?.name === 'string' && e.target.name.startsWith('options['))
        ) {
          // Allow other listeners to update the PDP price nodes, then sync; fallback covers gaps.
          setTimeout(() => this.refreshSubmitFromPDP(), 0);
        }
      }

      refreshSubmitFromPDP() {
        const v = this.getCurrentVariant();
        const disable = !v || !v.available;
        this.toggleSubmitButton(disable);
      }

      updateButton(html, selector, containerSelector, attach) {
        const next = html.querySelector(selector);
        const current = document.querySelector(selector);
        const container = document.querySelector(containerSelector);

        if (current && next) {
          current.replaceWith(next);
          const el = document.querySelector(selector);
          attach?.(el);
          return el;
        }

        if (current && !next) {
          current.classList.add('hide');
          return current;
        }

        if (!current && next) {
          container?.appendChild(next);
          attach?.(next);
          return next;
        }

        return null;
      }

      refreshPreorderButtons(html) {
        this.preOrderButton = this.updateButton(
          html,
          '.js-product-atc-pre-order',
          '.js-pre-order-button-container',
          (el) => el.addEventListener('click', this.preOrderClickHandler.bind(this))
        );

        this.preOrderButtonDays = this.preOrderButton?.dataset.preorderDays || null;
        this.preOrderButtonShipDate = this.preOrderButton?.querySelector('.js-product-atc-pre-order-ship-estimate-date') || null;

        this.formatPreOrderShipDate(
          this.preOrderButtonDays,
          this.preOrderButton,
          this.preOrderButtonShipDate,
        );

        this.bundlePreOrderButton = this.updateButton(
          html,
          '.js-product-bundle-pre-order-atc',
          '.js-bundle-pre-order-button-container',
          (el) => el.addEventListener('click', (e) => {
            e.preventDefault();
            window.SDG?.preOrderAddToCart?.(e.currentTarget);
          }),
        );

        this.bundlePreOrderButtonDays = this.bundlePreOrderButton?.dataset.bundlePreorderDays || null;
        this.bundlePreOrderButtonShipDate = this.bundlePreOrderButton?.querySelector('.js-bundle-ship-estimate-date') || null;

        console.log('formatPreOrderShipDate this.bundlePreOrderButtonDays', this.bundlePreOrderButtonDays);
        console.log('formatPreOrderShipDate this.bundlePreOrderButtonShipDate', this.bundlePreOrderButtonShipDate);

        this.formatPreOrderShipDate(
          this.bundlePreOrderButtonDays,
          this.bundlePreOrderButton,
          this.bundlePreOrderButtonShipDate,
        );
      }

      getCurrentVariant() {
        const idStr = this.variantIdInput?.value ? String(this.variantIdInput.value) : null;
        if (idStr && idStr === this.cachedVariantId) return this.cachedVariant;
        const v = idStr ? (this.variantIndex.get(idStr) || null) : null;
        this.cachedVariantId = idStr;
        this.cachedVariant = v;
        return v;
      }

      isTrulySoldOut() {
        const v = this.getCurrentVariant();
        return v ? v.available === false : false;
      }

      preOrderClickHandler(evt) {
        evt.preventDefault();
        if (evt.target.getAttribute('aria-disabled') === 'true') return;
        if (!evt.target.classList.contains('js-product-atc-pre-order')) return;

        // Get PDP variant data
        const pdpProductformData = new FormData(this.form);
        const pdpVariantId = pdpProductformData.get('id');
        const pdpVariant = SDG.Data.productJson.variants
          .find((variant) => variant.id === parseInt(pdpVariantId, 10));
        const $preOrderJsonScript = this.preOrderButton.querySelector('.js-product-atc-pre-order-data');
        // Get matching pre-order variant
        const preOrderProductData = JSON.parse($preOrderJsonScript.textContent);
        const preOrderVariant = preOrderProductData.variants
          .find((variant) => variant.title.toLowerCase() === pdpVariant.title.toLowerCase());
        // Shipping message
        const { preOrderShippingMessage } = this.preOrderButton.dataset;

        const body = {
          items: [{
            id: preOrderVariant.id,
            quantity: 1,
            properties: {
              _olpid: preOrderProductData.id,
              _olvid: preOrderVariant.id,
              Shipping: preOrderShippingMessage,
              _olpre: 'preorder',
            },
          }],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
        };

        const $primaryCtaText = evt.target.querySelector('.js-product-atc-pre-order-text-primary');
        const $shipEstimateText = evt.target.querySelector('.js-product-atc-pre-order-text-ship-estimate');
        const $addingText = evt.target.querySelector('.js-product-atc-pre-order-text-adding');
        const $loadingSpinner = evt.target.querySelector('.loading__spinner');

        // Toggle button text
        $primaryCtaText?.classList.add('visibility-hidden');
        $shipEstimateText?.classList.add('visibility-hidden');
        $addingText?.classList.remove('hide');
        $loadingSpinner.classList.remove('hidden');
        evt.target.setAttribute('disabled', true);
        evt.target.setAttribute('aria-disabled', true);
        evt.target.classList.add('loading');

        // Add pre-order to cart
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            this.error = false;
            if (this.cart) {
              this?.cart?.renderContents(data);
            }
          })
          .catch((error) => {
            console.error('Error adding pre-order to cart:', error);
          })
          .finally(() => {
            evt.target?.classList.remove('loading');
            $primaryCtaText?.classList.remove('visibility-hidden');
            $shipEstimateText?.classList.remove('visibility-hidden');
            $addingText?.classList.add('hide');

            if (!this.error) {
              evt.target.removeAttribute('aria-disabled');
              evt.target?.removeAttribute('disabled');
            }

            $loadingSpinner.classList.add('hidden');
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (evt.submitter.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const bundleDataEl = document.querySelector('#bundle-data');

        if (bundleDataEl) {
          const bundleItems = JSON.parse(bundleDataEl.dataset.bundle || '[]');

          if (!bundleItems.length) {
            this.handleErrorMessage('Bundle is not configured correctly');
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            return;
          }

          const payload = {
            items: bundleItems,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
            .then((res) => res.json())
            .then((response) => {
              if (!this.cart) {
                window.location = window.routes.cart_url;
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((error) => {
              console.error('Error adding bundle to cart:', error);
              this.handleErrorMessage('Failed to add bundle to cart');
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            });

          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            // Update js-cart-count
            const cartCount = document.querySelectorAll('.js-cart-count');
            cartCount.forEach((el) => {
              el.textContent = parseInt(el.textContent, 10) + 1;
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this?.cart?.renderContents(response);
                    });
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this?.cart?.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable, text) {
        const trulySoldOut = this.isTrulySoldOut();
        // Always reset UI first
        if (this.ctaEl) this.ctaEl.classList.add('hide');
        // Always show loading spinner initially when changing variants
        if (this.submitButtonLoadingSpinner) this.submitButtonLoadingSpinner.classList.remove('hidden');
        // Handle disabled state (applies to both sold out and loading states)
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (this.submitPriceContainer) this.submitPriceContainer.classList.add('hide');
          if (this.readyToShipText) this.readyToShipText.classList.add('hide');
        }
        // Handle sold out state (separate from disabled state)
        if (trulySoldOut) {
          if (this.submitButtonLoadingSpinner) this.submitButtonLoadingSpinner.classList.add('hidden');
          if (this.ctaEl) {
            this.ctaEl.classList.remove('hide');
            this.ctaEl.textContent = text || window.variantStrings.soldOut || 'Sold out';
            if (this.compareEl) this.compareEl.textContent = '';
            if (this.priceEl) this.priceEl.textContent = '';
          }
        }
        // Handle available state
        if (!disable && !trulySoldOut) {
          // For enabled button (available product)
          this.ctaEl.classList.add('hide');
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitPriceContainer) this.submitPriceContainer.classList.remove('hide');
          if (this.readyToShipText) this.readyToShipText.classList.remove('hide');
          if (this.submitButtonLoadingSpinner) this.submitButtonLoadingSpinner.classList.add('hidden');
          if (this.ctaEl) {
            this.ctaEl.classList.remove('hide');
            this.ctaEl.textContent = window.variantStrings.addToCart || 'Add to cart';
          }
          const compareNode = document.querySelector('.js-compare-at-price');
          const priceNode = document.querySelector('.js-regular-price');
          const compareText = (compareNode?.textContent || '').trim();
          const priceText = (priceNode?.textContent || '').trim();
          if (this.compareEl) this.compareEl.textContent = compareText;
          if (this.priceEl) this.priceEl.textContent = priceText;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
